import * as Glob from "../../Globale";

export interface IConnectedField {
    FieldsNames: string[];
    WarrantyId: string;
}

export const ConnectedFields: IConnectedField[] = [
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_DirezioneSanitaria, FieldsNames: ["DirettoreSanitario"] },



    /*Avvocati*/
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_FunzioniPubbliche, FieldsNames: ["FunzioniPubbliche"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_AttFiscRevEntiPubb, FieldsNames: ["Revisore"] },

    /*acc*/
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_Sindaco, FieldsNames: ["Sindaco"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_FunzioneRevisoreContabile, FieldsNames: ["RevisoreComm"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_FunzioneRevisoreContabileNew, FieldsNames: ["RevisoreNew"] },

    { WarrantyId: Glob.Tipi_RCPG_Accessoria_FunzioneRevisoreContabileEP, FieldsNames: ["RevisoreCommEP"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_MembroCdA, FieldsNames: ["MembroCdA"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_OCC, FieldsNames: ["OCC"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_ODV, FieldsNames: ["ODV"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_AmministratoreCondomini, FieldsNames: ["StabiliCondominiali"] },

    /*commercialisti*/
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_VistoLeggero, FieldsNames: ["VistoLeggero"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_VistoPesante, FieldsNames: ["VistoPesante"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_LiquidazioneCuratela, FieldsNames: ["LiquidazioneCuratela"] },
    { WarrantyId: Glob.Tipi_RCPG_Accessoria_FusioniAcquisizioni, FieldsNames: ["FusioniAcquisizioni"] },
    /* { WarrantyId: Glob.Tipi_RCPG_Accessoria_LiquidazioneCuratela, FieldsNames: ["Curatore"] },*/

    { WarrantyId: Glob.Tipi_RCPG_Accessoria_PatrocinatoriStragiudiziali, FieldsNames: ["PatrocinatoriStragiudiziali"] },


];

export const ProductTypeIdsExceptions = [25, 34, 31, 32, 30];
export const ProductTypeIdsAdd = [137];



// WEBPACK FOOTER //
// ./src/components/RCP/config.ts